<div fxLayout="column" fxFlexFill>
  <div fxLayout="column" fxFlexFill class="spinner-container" *ngIf="dataSource.loading$ | async">
    <mat-spinner></mat-spinner>
  </div>
  <div fxFlex="auto" fxFlexFill class="table-container">
    <mat-table [dataSource]="dataSource" multiTemplateDataRows class="regular-table responsive"
               matSort matSortActive="date" matSortDirection="desc" matSortDisableClear>
      <ng-container matColumnDef="date">
        <mat-header-cell *matHeaderCellDef mat-sort-header="date">Date</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Date:</span>
          <span>
            {{row.date | dateTime: 'M/dd/yyyy hh:mm a'}}
          </span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="type">
        <mat-header-cell *matHeaderCellDef mat-sort-header="type">Type</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Type:</span>
          <span>{{getTypeName(row.type)}}</span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="category">
        <mat-header-cell *matHeaderCellDef mat-sort-header="category">Category</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Category:</span>
          {{ getCategoryName(row.category) }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="username">
        <mat-header-cell *matHeaderCellDef mat-sort-header="username">Username</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Username:</span>
          {{ row.username }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="details">
        <mat-header-cell *matHeaderCellDef mat-sort-header="details">Details</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Details:</span>
          {{row.details}}
          <a (click)="navigateToDetails(row)" style="cursor: pointer">
            <i class="material-icons" style="font-size: 19px; vertical-align: middle;">
              open_in_browser
            </i>
          </a>
        </mat-cell>
      </ng-container>


      <!-- Header and Row Declarations -->
      <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns" class="call-logs-row"></mat-row>
    </mat-table>
  </div>
  <mat-paginator fxFlex="initial" [length]="dataSource.dataCount$ | async" [pageSize]="100"></mat-paginator>
</div>
